<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <loadingcomp
      v-bind:mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>
    <v-dialog v-model="paximumSaticiDialog" max-width="400px">
      <v-card flat color="grey lighten-4">
        <v-card-title>Paximum Otel Ekle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md12>
              <v-layout row="" wrap="">
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap justify-space-between column>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete
                        hide-details
                        append-icon="search"
                        id="searchValue"
                        clearable
                        label="Paximum Otel Ara"
                        :items="items"
                        item-text="isimAra"
                        item-value="kod"
                        v-model="Satici"
                        return-object
                        :required="required"
                        :rules="rules"
                        :readonly="readonly"
                        :search-input.sync="search"
                        :disabled="aktifmi"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-text-field label="Otel" v-model="Satici.isim">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-select
                        :items="saticiTipi"
                        v-model="Satici.YurtIci_YurtDisi"
                        item-text="text"
                        item-value="value"
                        :label="$t('Seller-Type')"
                      >
                      </v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-textarea :label="$t('Address_label')" v-model="Satici.Adres">
                      </v-textarea>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-text-field :label="$t('Telephone')" v-model="Satici.Tel1">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="paximumSaticiDialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="paximumOtelInsert()"
            > {{ $t('save_button') }} </v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import auth from "@/api/auth";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import tool from "../../coper/tools";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  props: {
    value: {},
    readonly: {
      default: false,
    },
    required: {
      default: false,
    },
    rules: {},
    aktifmi: {
      default: false,
    },
    SaticiTip: {
      type: Number,
    },
  },
  data() {
    return {
      text1: "",
      snackbar: false,
      paximumSaticiDialog: false,
      saticiTipi: [
        {
          text: "Yurtiçi",
          value: 0,
        },
        {
          text: "Yurtdışı",
          value: 1,
        },
      ],
      loadingmesaj: "",
      loadingvmodel: false,
      SaticiDialog: {
        SaticiTipi: 1,
        Ref: null,
        SirketNo: null,
        Kod: null,
        Isim: null,
        Cari_Kod: {
          id: null,
          kod: null,
          isim: null,
        },
        Adres: null,
        PK: null,
        Ulke: null,
        Sehir: null,
        Yer: null,
        SaticiKonumu: null,
        Yetkili: null,
        Web: null,
        HavaAlani: null,
        VDaire: null,
        VNo: null,
        Tel1: null,
        Tel2: null,
        Fax: null,
        Teleks: null,
        Email: null,
        GSM: null,
        Ic_Dis: "0",
        Aciklamalar: null,
        LocationF: null,
        OdaTanimlari: null,
        OtelOzellikleri: null,
        krdDerece: null,
        krdDakika: null,
        krdSaniye: null,
        krdDereceM: null,
        krdDakikaM: null,
        krdSaniyeM: null,
        Grup: null,
        PasifKayit: false,
        GlobalKod: null,
        ZincirKodu: null,
        CreatedBy: null,
        CreatedDate: null,
        ModifiedBy: null,
        ModifiedDate: null,
        AutoCreate: null,
        stOtel: {
          Ucretsizler: [],
          Ucretliler: [],
          Kategori: null,
          GenelMudur: null,
          SatisMuduru: null,
          MuhasebeMuduru: null,
          Donem1: null,
          Donem2: null,
          BarLokanta: null,
          KonferansOda: null,
          OdaKonum: [],
          MinKisi: null,
          OpSure: null,
          Bedava1: null,
          Bedava2: null,
          Cocuk1: null,
          Cocuk2: null,
          OtelTip: null,
          AutoCreate: null,
        },
        stArac: null,
        stRestaurant: null,
        stAcente: null,
        stRentACar: null,
        stRehber: null,
        stMuze: null,
        stCharter: null,
        stGemi: null,
        stDiger: null,
        stTurOperatoru: null,
        stKonsolosluk: null,
        stSigorta: null,
        stFeribot: null,
        stGolf: null,
      },
      ayrac: "  -  ",
      items: [],
      paximumToken: null,
      search: null,
      paximumParams: {
        Agency: "PXM115832",
        User: "USR1",
        Password: "Shall2021!",
      },
    };
  },
  computed: {
    Satici: {
      get: function () {
        var r = {
          id: "",
          isim: "",
          kod: "",
          isimAra: "",
          YurtIci_YurtDisi: 0,
          Adres: "",
          Tel1: "",
          CariKod: "",
          KDV: 0,
        };
        if (
          this.value != undefined &&
          this.value != null &&
          this.value.id != null
        ) {
          r = {
            id: this.value.id,
            KDV: this.value.KDV,
            isim: this.value.isim,
            kod: this.value.kod,
            Adres: this.value.Adres,
            Tel1: this.value.Tel1,
            YurtIci_YurtDisi: this.value.YurtIci_YurtDisi,
            isimAra: this.value.isim + this.ayrac + this.value.kod,
            CariKod: this.value.CariKod,
          };
        }

        this.SetItems(r);
        return r;
      },
      set: function (newValue) {
        if (newValue == null) {
          newValue = {
            id: "",
            isim: "",
            kod: "",
            isimAra: "",
            YurtIci_YurtDisi: "",
            CariKod: "",
            KDV: 0,
          };
        }
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    dialogOpen() {
      this.paximumSaticiDialog = true;
    },
    paximumOtelInsert() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      if (this.Satici.isim != null) {
        this.loadingvmodel = true;
        this.SaticiDialog.SirketNo = credentials.CoperSirketNo;
        this.SaticiDialog.Kod = this.Satici.kod;
        this.SaticiDialog.Isim = this.Satici.isim;
        this.SaticiDialog.Adres = this.Satici.Adres;
        this.SaticiDialog.Tel1 = this.Satici.Tel1;
        tool.http_post(this, "SaticiKayit", this.SaticiDialog).then(
          (response) => {
            if (response.body.Status == true) {
              this.loadingvmodel = false;
              this.paximumSaticiDialog = false;
              this.snackbar = true;
              this.text1 = " Otel Eklendi";
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.paximumSaticiDialog = false;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            this.status = tool.responseToStatus(response);
            this.paximumSaticiDialog = false;
            this.loadingvmodel = false;
          }
        );
      } else {
        this.snackbar = true;
        this.text1 = this.$t('Hotel-Name-cannot-Blank');
      }
    },
    querySelections(v) {
      var prm = {
        id: "",
        kod: "",
        aciklama: v,
        tip: 1,
      };
      setTimeout(() => {
        this.searchSatici(v);
      }, 600);
    },
    turkceKarakterControl(text) {
      var trMap = {
        çÇ: "c",
        ğĞ: "g",
        şŞ: "s",
        üÜ: "u",
        ıİ: "i",
        öÖ: "o",
      };
      for (var key in trMap) {
        text = text.replace(new RegExp("[" + key + "]", "g"), trMap[key]);
      }
   
      return text.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
        letter.toLowerCase());
    },
    searchSatici(searchText) {
      var paxItemsCount = 0;
      if (searchText.length > 2) {
        var params = {
          ProductType: 2,
          Query: searchText,
        };
        this.$http
          .post(
            auth.PAXIMUM_API_URL + "api/productservice/getarrivalautocomplete",
            params,
            {
              headers: {
                Authorization: "Bearer " + this.paximumToken,
              },
            }
          )
          .then(
            (response) => {
              this.items = [];
              for (
                let index = 0;
                index < response.body.body.items.length;
                index++
              ) {
                const element = response.body.body.items[index];
                if (Number(element.type) == 2 && 5 >= paxItemsCount) {
                  var icDis = 0;
                  if (element.country.id == "TR") {
                    icDis = 0;
                  } else {
                    icDis = 1;
                  }
                  paxItemsCount++;
                  this.items.push({
                    id: "",
                    isim: this.turkceKarakterControl(element.hotel.name),
                    KDV: "",
                    kod: "Px" + element.hotel.id,
                    CariKod: "",
                    YurtIci_YurtDisi: icDis,
                    Adres:
                      element.state.name +
                      " - " +
                      element.city.name +
                      " - " +
                      element.country.name,
                    Tel1: "",
                    isimAra:
                      "Px" + element.hotel.id + this.ayrac + this.turkceKarakterControl(element.hotel.name),
                  });
                }
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-getarrivalautocomplete";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-getarrivalautocomplete";
                this.snackbar = true;
              }
            }
          );
      }
    },
    IsimAra(v) {
      var text = null;

      if (v.isim != null) {
        text = v.isim.replace(this.ayrac, "-");
      }
      text = text + this.ayrac;
      if (v.kod != null) {
        text = text + v.kod.replace(this.ayrac, "-");
      }
      return text;
    },
    SetItems(v) {
      var vid = String(v.id);
      var vkod = String(v.kod);
      if (v.kod != null && vkod.length > 0) {
        this.items = [v];
      } else {
        this.items = [];
      }
    },
  },
  components: {
    snackbarcomp,
    loadingcomp,
  },
  watch: {
    search(val) {
      if (val != undefined && val == "") {
        this.items = [
          {
            id: "",
            isim: "",
            kod: "",
            isimAra: "",
            YurtIci_YurtDisi: "",
            CariKod: "",
            KDV: 0,
          },
        ];
        this.Satici = {
          id: "",
          isim: "",
          kod: "",
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0,
        };
      } else {
        val &&
          val.indexOf(this.ayrac) == -1 &&
          val.length > 1 &&
          this.querySelections(val);
      }
    },
  },
  created() {
    this.$http
      .post(
        auth.PAXIMUM_API_URL + "api/authenticationservice/login",
        this.paximumParams
      )
      .then(
        (response) => {
          this.paximumToken = response.body.body.token;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-authenticationservice";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable-authenticationservice";
            this.snackbar = true;
          }
        }
      );
  },
};
</script>

<style>
</style>